import AnalogClock from "./AnalogClock";
import * as ClockThemes from "./themes";

export const Themes = ClockThemes;
export default AnalogClock;
